import { createSelector } from '@reduxjs/toolkit'
import { Nullish, RootState, School, Sport } from 'types'
import { FEATURE_NAME, IState } from '../Init.model'

export const selectInitSlice = (state: RootState): IState => state.app[FEATURE_NAME]

export const selectWidgetTitle = createSelector(
  selectInitSlice,
  (slice): Nullish<string> => slice.title,
)

export const selectWidgetTitleFontSize = createSelector(
  selectInitSlice,
  (slice): number => slice.titleFontSize,
)

export const selectSchool = createSelector(
  selectInitSlice,
  (slice): Nullish<School> => slice.school,
)

export const selectSport = createSelector(selectInitSlice, (slice): Nullish<Sport> => slice.sport)
